module.exports = __webpack_public_path__ + "static/media/CB_engagement_7.b3211ae0.jpg";